import { Outlet, Route, Routes } from 'react-router-dom'

import { CertificateQuizRoute } from 'src/routes/CertificateQuiz'
import { CertificateStartRoute } from 'src/routes/CertificateStart'
import { CertificateStatsRoute } from 'src/routes/CertificateStats'
import { NotFoundRoute } from 'src/routes/NotFound'

export function Router() {
    return (
        <Routes>
            <Route path="/" element={<Outlet />}>
                <Route path="certificate/:_id" element={<Outlet />}>
                    <Route index element={<CertificateStartRoute />} />
                    <Route path="quiz" element={<CertificateQuizRoute />} />
                    <Route path="stats" element={<CertificateStatsRoute />} />
                </Route>
                <Route path="*" element={<NotFoundRoute />} />
            </Route>
        </Routes>
    )
}
